<div class="modal-container">
  <div class="modal-content">
    <div class="quick-order-modal-submit">
      <div class="modal-header">
        @if ((isCustomTranslationsEnabled$ | async) !== null) {
        <h4
          class="modal-title"
          id="modal-basic-title"
          [innerHtml]="
            'cart.quickOrder.submitModal.title'
              | cxTranslate
                : {
                    context: setCustomContext(
                      isCustomTranslationsEnabled$ | async,
                      activeCountry$ | async,
                      activeLanguage$ | async
                    )
                  }
          "
        ></h4>
        }
        <button
          type="button"
          class="close"
          aria-label="Close"
          [disabled]="showSpinner"
          (click)="closeModal('Cross click')"
        >
          <mat-icon svgIcon="modal-x-icon"></mat-icon>
        </button>
      </div>
      <div class="modal-body">
        <div class="modal-info" [innerHtml]="'cart.quickOrder.submitModal.modalInfo' | cxTranslate"></div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-default secondary-btn cancel-btn mw-120"
          [ngClass]="{ disabled: showSpinner, notEn: customizeStylingButtons(activeLanguage$ | async) }"
          [disabled]="showSpinner"
          [innerHtml]="'cart.quickOrder.submitModal.cancel' | cxTranslate"
          (click)="closeModal('Cross click')"
        ></button>
        @if ((isCustomTranslationsEnabled$ | async) !== null) {
        <button
          type="button"
          class="btn btn-outline-default primary-btn save-btn mw-120"
          [ngClass]="{ rotating: showSpinner, notEn: customizeStylingButtons(activeLanguage$ | async) }"
          [disabled]="showSpinner"
          [class.disabled]="showSpinner"
          (click)="submitEntries(entries)"
        >
          {{
            showSpinner
              ? ''
              : ('cart.quickOrder.submitModal.continue'
                | cxTranslate
                  : {
                      context: setCustomContext(
                        isCustomTranslationsEnabled$ | async,
                        activeCountry$ | async,
                        activeLanguage$ | async
                      )
                    })
          }}
        </button>
        }
      </div>
    </div>
  </div>
</div>
